<template>
  <div id='app' class='app'>
    <app-refresh />
    <router-view />
    <app-toaster />
    <portal-target name="app-modal"></portal-target>
    <vue-up />
    <features-pub-modal
      @close="switchWelcomeWesave"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
  import { subscribe, unsubscribe } from '@/api'
  import appRefresh from '@/pages/authenticated/app-refresh'
  import appToaster from '@/components/app-toaster'
  import featuresPubModal from '@/components/modals/FeaturesPubModal'
  import { axeptio } from '@/mixins/axeptio'

  export default {
    name: 'app',
    components: {
      appRefresh,
      appToaster,
      featuresPubModal
    },

    mixins: [axeptio],

    metaInfo () {
      return {
        title: this.$t(`brandnames.${this.brandname}`),
        titleTemplate: '%s'
      }
    },

    computed: {
      ...mapGetters({
        isEsrSsoRestriction: 'isEsrSsoRestriction',
        isSso: 'isSso',
        isAdvisor: 'auth/isAdvisor'
      }),
      ...mapState({
        brandname: state => state.brandname,
        errorResponse: state => state.error.response,
        authenticated: state => state.auth.authenticated,
        cguValidated: state => state.auth.user && state.auth.user.cguValidated
      })
    },

    created () {
      this.authChanged()
    },

    mounted () {
      if (process.env.AXEPTIO_ID) {
        this.listenAxeptioValidation()
      }
      console.log(`${this.$t(`brandnames.${this.brandname}`)} started with version ${VERSION}`)
    },

    methods: {
      ...mapActions({
        fetchUser: 'auth/fetchUser'
      }),
      ...mapMutations({
        switchWelcomeWesave: 'switchWelcomeWesave'
      }),
      authChanged () {
        if (this.authenticated) {
          subscribe()

          this.fetchUser()
            .then(() => {
              const routeName = this.$route.name
              if (this.isEsrSsoRestriction && !this.cguValidated && routeName !== 'keycloak-callback' && routeName !== 'cgu') {
                this.$router.push({ name: 'keycloak-callback' })
              } else {
                if (!this.isEsrSsoRestriction && routeName !== 'keycloak-callback') {
                  this.createAxeptioScriptTag()
                }
              }
            })
        } else {
          unsubscribe()
        }
      }
    },

    watch: {
      authenticated () {
        this.authChanged()
      },

      errorResponse (response) {
        if (!response) return

        const { status } = response

        if (Math.floor(status / 100) === 5) {
          this.$router.push({ name: 'error500' })
        }
      }
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/reset';
  @import '~@/styles/common';

  #app {
    overflow-y: hidden
  }

  div.app > .app-toaster {
    padding-top: 8rem;
  }
</style>
